<h1 matDialogTitle>Upload Supporting Document(s)</h1>

<mat-dialog-content>
  <div>
    <form [formGroup]="form">
      <form [formGroup]="form" style="width: 100%">
        <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">
          <mat-form-field fxFlex="100" width="100%"
            *ngIf="supportingDocumentTypes && supportingDocumentTypes.length > 0">
            <mat-label>Supporting Document Type</mat-label>
            <mat-select formControlName="supportingDocumentTypeId">
              <mat-option *ngFor="let supportingDocumentType of supportingDocumentTypes"
                [value]="supportingDocumentType.supportingDocumentTypeId">
                {{supportingDocumentType.supportingDocumentTypeDesc}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="file-label">Supporting Document</div>
          <kendo-fileselect [multiple]="true" [showFileList]="true" (select)="filesSelected($event)"
            (remove)="fileRemoved($event)" style="margin-bottom: 16px" [restrictions]="fileRestrictions"
            [accept]="fileAccept">
          </kendo-fileselect>
          <!-- <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
            <mat-error class="file-error" *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
          </ng-container> -->
        </div>
      </form>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Upload Document(s)</button>
</mat-dialog-actions>